// import React from 'react'

import { Card, CardBody, CardHeader } from "@components/card/card";
import { useAppDispatch } from "@store/hooks";
import { TreeSelect } from "antd";
import { useState } from "react";
import Select from 'react-select';

import { useNavigate } from "react-router";
import { Form } from "react-bootstrap";
import { getUnApplyPrepaymentsListByPeopleId } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';

// const PrePaymentRefundComponent = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default PrePaymentRefundComponent


export const PrePaymentRefundComponent: React.FC<{
  formik: any;
  onClose: () => void;
  OperatingUnitOptions: any[];
  treeSuppliersData: any[];
}> = ({ formik, onClose, OperatingUnitOptions, treeSuppliersData }) => {
  const { values, setFieldValue } = formik;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // State خاص بالمكون
  const [prepaymentList, setPrepaymentList] = useState<any[]>([]);
  const [selectedPrepayment, setSelectedPrepayment] = useState<any>(null);
  const [refundAmount, setRefundAmount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);

  const resetState = () => {
    setPrepaymentList([]);
    setSelectedPrepayment(null);
    setRefundAmount(0);
    setFetchError(null);
    setIsLoading(false);
  };

  const handleGetPrepayments = async () => {
    if (!values.organizationId || !values.peopleId) return;

    setIsLoading(true);
    setFetchError(null);

    try {
      const result = await dispatch(
        getUnApplyPrepaymentsListByPeopleId({
          peopleId: values.peopleId,
          organizationId: values.organizationId
        })
      ).unwrap();

      let prepaymentData: any[] = [];

      if (result.succeeded) {
        prepaymentData = result.data
          .filter((prepayment: any) => prepayment.amountUnApply > 0) // فقط الدفعات التي لها رصيد متبقي
          .map((prepayment: any) => ({
            amount: prepayment.amount,
            amountUnApply: prepayment.amountUnApply,
            code: prepayment.code,
            id: prepayment.id,
            paymentDate: prepayment.paymentDate
          }));
        setPrepaymentList(prepaymentData);
      }

      if (!result.succeeded || prepaymentData.length === 0) {
        setFetchError('لا توجد دفعات مسبقة متاحة للاسترداد');
      }
    } catch (error) {
      console.error('Error fetching prepayments:', error);
      setFetchError('فشل في جلب بيانات الدفعات المسبقة');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrepaymentSelection = (prepayment: any) => {
    setSelectedPrepayment(prepayment);
    // عند الاختيار، نضع المبلغ الافتراضي كامل الرصيد المتبقي
    setRefundAmount(prepayment.amountUnApply);
  };

  const handleRefundAmountChange = (amount: number) => {
    if (!selectedPrepayment) return;

    const maxAmount = selectedPrepayment.amountUnApply;
    const finalAmount = Math.max(0, Math.min(amount, maxAmount));
    setRefundAmount(finalAmount);
  };

  const handleSubmit = () => {
    if (!selectedPrepayment) {
      alert('يجب اختيار دفعة مسبقة للاسترداد');
      return;
    }

    if (refundAmount <= 0) {
      alert('يجب إدخال مبلغ استرداد أكبر من صفر');
      return;
    }

    if (refundAmount > selectedPrepayment.amountUnApply) {
      alert(
        `مبلغ الاسترداد (${refundAmount.toLocaleString()}) لا يمكن أن يتجاوز الرصيد المتبقي (${selectedPrepayment.amountUnApply.toLocaleString()})`
      );
      return;
    }

    // إعداد القيم في الفورم الرئيسي
    formik.setFieldValue('amount', refundAmount);
    formik.setFieldValue('prePaymentId', selectedPrepayment.id);
    formik.setFieldValue('scheduleList', []); // لا جدول سداد لهذا النوع

    onClose();
  };

  // التحقق من صلاحية النموذج
  const isFormValid = !!selectedPrepayment && refundAmount > 0 && refundAmount <= (selectedPrepayment?.amountUnApply || 0);

  // الرصيد بعد الاسترداد
  const remainingAfterRefund = selectedPrepayment ? selectedPrepayment.amountUnApply - refundAmount : 0;

  return (
    <>
      <div className='row g-3 mb-4'>
        {/* المورد والوحدة التشغيلية */}
        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>المورد</label>
            <TreeSelect
              showSearch
              className='w-100'
              treeLine
              placeholder='اختر المورد'
              allowClear
              value={values.peopleId}
              onChange={option => {
                resetState();
                formik.setFieldValue('peopleId', option === null ? null : option);
              }}
              treeData={treeSuppliersData}
              treeNodeFilterProp='title'
              getPopupContainer={triggerNode => triggerNode.parentNode}
            />
          </div>
        </div>

        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>الوحدة التشغيلية</label>
            <Select
              isSearchable={true}
              isClearable
              options={OperatingUnitOptions}
              value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
              onChange={(option: any) => {
                resetState();
                setFieldValue('organizationId', option === null ? null : option.value);
              }}
              placeholder='اختر الوحدة التشغيلية'
              className='react-select-container'
              classNamePrefix='react-select'
            />
          </div>
        </div>

        <div className='col-lg-2'>
          <div className='form-group h-100 d-flex flex-column justify-content-end'>
            <button
              disabled={isLoading || !values.organizationId || !values.peopleId}
              type='button'
              className='btn btn-sm btn-outline-theme w-100 py-2'
              onClick={handleGetPrepayments}
            >
              {isLoading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2'></span>
                  جاري التحميل...
                </>
              ) : (
                <>
                  <i className='fas fa-download me-2'></i>
                  جلب البيانات
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {fetchError && (
        <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
          <i className='fas fa-exclamation-triangle me-2'></i>
          <div>{fetchError}</div>
        </div>
      )}

      {/* قائمة الدفعات المسبقة المتاحة للاسترداد */}
      {prepaymentList.length > 0 && (
        <div className='row mb-4'>
          <div className='col-12'>
            <Card className='border-orange'>
              <CardHeader className='bg-orange bg-opacity-10 border-orange d-flex justify-content-between align-items-center py-3'>
                <h6 className='mb-0'>
                  <i className='fas fa-undo-alt me-2 text-orange'></i>
                  اختر الدفعة المقدمة للاسترداد
                </h6>
                <small className=' '>{prepaymentList.length} دفعة متاحة</small>
              </CardHeader>
              <CardBody className='p-0'>
                <div className='list-group list-group-flush'>
                  {prepaymentList.map((prepayment) => (
                    <div
                      key={prepayment.id}
                      className={`list-group-item list-group-item-action border-bottom ${
                        selectedPrepayment?.id === prepayment.id
                          ? 'bg-orange bg-opacity-10 border-orange border-2'
                          : 'border-light'
                      }`}
                      onClick={() => handlePrepaymentSelection(prepayment)}
                      style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                    >
                      <div className='d-flex justify-content-between align-items-start'>
                        <div className='d-flex align-items-start flex-grow-1'>
                          <div className='form-check mt-1 me-3'>
                            <input
                              type='radio'
                              className='form-check-input'
                              name='prepaymentRefund'
                              checked={selectedPrepayment?.id === prepayment.id}
                              onChange={() => handlePrepaymentSelection(prepayment)}
                            />
                          </div>
                          <div className='flex-grow-1'>
                            <div className='d-flex align-items-center mb-2'>
                              <h6 className='mb-0 me-3'>{prepayment.code}</h6>
                              <span className='badge bg-secondary small'>
                                <i className='fas fa-calendar me-1'></i>
                                {prepayment.paymentDate?.split('T')[0]}
                              </span>
                            </div>

                            <div className='row g-3'>
                              <div className='col-auto'>
                                <div className='d-flex flex-column'>
                                  <small className='mb-1'>المبلغ الكامل</small>
                                  <span className='fw-bold fs-6'>
                                    {Number(prepayment.amount).toLocaleString()}
                                  </span>
                                </div>
                              </div>

                              <div className='col-auto'>
                                <div className='vr h-100'></div>
                              </div>

                              <div className='col-auto'>
                                <div className='d-flex flex-column'>
                                  <small className='text-muted mb-1'>الرصيد المتبقي</small>
                                  <span className='fw-bold text-orange fs-6'>
                                    {Number(prepayment.amountUnApply).toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='text-end ms-3'>
                          <div className='d-flex flex-column align-items-end'>
                            <span className={` fs-16px fw-bold ${selectedPrepayment?.id === prepayment.id ? 'text-theme' : ''}`}>
                              {Number(prepayment.amountUnApply).toLocaleString()}
                            </span>
                            <small className='text-muted mt-1'>
                              متبقي للاسترداد
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      )}

      {/* حقل مبلغ الاسترداد وملخص */}
      {selectedPrepayment && (
        <>
          <div className='row mb-4'>
            <div className='col-lg-4 offset-lg-4'>
              <div className='form-group'>
                <label className='form-label fw-bold text-orange'>
                  مبلغ الاسترداد <span className='text-danger'>*</span>
                </label>
                <Form.Control
                  className='text-center fw-bold fs-5 border-orange'
                  type='number'
                  value={refundAmount || ''}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = parseFloat(e.target.value) || 0;
                    handleRefundAmountChange(value);
                  }}
                  min='0'
                  max={selectedPrepayment.amountUnApply}
                  step='0.01'
                  placeholder='0'
                />
                <small className='text-muted d-block text-center mt-1'>
                  الحد الأقصى: {selectedPrepayment.amountUnApply.toLocaleString()}
                </small>
              </div>
            </div>
          </div>

          <div className={`alert ${isFormValid ? 'alert-success' : 'alert-warning'} mb-4`}>
            <div className='row text-center'>
              <div className='col-md-4 border-end'>
                <div className='small text-muted'>رصيد الدفعة المسبقة</div>
                <div className='h5 fw-bold text-orange'>{selectedPrepayment.amountUnApply.toLocaleString()}</div>
                <small className='text-muted'>دفعة: {selectedPrepayment.code}</small>
              </div>
              <div className='col-md-4 border-end'>
                <div className='small text-muted'>مبلغ الاسترداد</div>
                <div className='h5 fw-bold text-primary'>{refundAmount.toLocaleString()}</div>
              </div>
              <div className='col-md-4'>
                <div className='small text-muted'>الرصيد المتبقي بعد الاسترداد</div>
                <div className={`h5 fw-bold ${remainingAfterRefund > 0 ? 'text-success' : 'text-warning'}`}>
                  {remainingAfterRefund.toLocaleString()}
                </div>
              </div>
            </div>
            {!isFormValid && refundAmount > selectedPrepayment.amountUnApply && (
              <div className='mt-2 text-center text-danger'>
                <i className='fas fa-exclamation-triangle me-2'></i>
                مبلغ الاسترداد يتجاوز الرصيد المتاح
              </div>
            )}
          </div>

          <div className='alert alert-info d-flex align-items-center mb-4'>
            <i className='fas fa-info-circle me-2 fa-lg'></i>
            <div>
              <h6 className='alert-heading mb-1'>استرداد دفع مسبق</h6>
              <p className='mb-0'>يتم استرداد مبلغ من الدفعة المسبقة المختارة دون ربطها بفواتير</p>
            </div>
          </div>
        </>
      )}

      <div className='border-top mt-4 pt-4'>
        <div className='d-flex justify-content-between align-items-center'>
          <div></div>
          <div className='d-flex'>
            <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
              <i className='fas fa-check-circle me-2'></i>
              تأكيد الاسترداد
            </button>
            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={() => navigate('/AP/ApPayments', { replace: true })}
            >
              <i className='fas fa-times me-2'></i>
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </>
  );
};